// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeContactSubmitBody = {
  firstName: string;
  lastName: string;
  email: string;
  message: string;
  captchaToken?: string;
};

export type typeContactSubmitOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | Record<string, unknown>;
};

export type typeContactSubmitOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContactSubmitOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContactSubmitOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaContactSubmitBody = {
  type: "object",
  properties: {
    firstName: { type: "string", maxLength: 3000, minLength: 1 },
    lastName: { type: "string", maxLength: 3000, minLength: 1 },
    email: { type: "string", maxLength: 3000, minLength: 1 },
    message: { type: "string", maxLength: 3000, minLength: 1 },
    captchaToken: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["firstName", "lastName", "email", "message"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createContactSubmit(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaContactSubmitBody);
  }

  return async function postContactSubmit(
    payload: typeContactSubmitBody,
  ): Promise<typeContactSubmitOutput200 | typeContactSubmitOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postContactSubmit" failed before calling the network. #b4706d62ad15`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#b4706d62ad15" },
        },
        data: null,
      } as typeContactSubmitOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/contact/submit`,
      httpMethod: "POST",
      options,
    })) as typeContactSubmitOutput200 | typeContactSubmitOutput400;
  };
}
